<!-- bridge-quote-preview-v2.component.html -->

<div class="relative">
  <!-- 🔵 Backplate glow (dégradé bleu→indigo) -->
  <div class="absolute inset-0 rounded-2xl pointer-events-none"
       [ngClass]="isDarkMode()
         ? 'translate-x-1 translate-y-1 bg-gradient-to-r from-indigo-600 to-blue-600 opacity-80'
         : 'bg-gradient-to-r from-indigo-300 to-blue-300 opacity-50 blur-[2px]'">
  </div>

  <!-- 🧊 Panneau principal (verre fumé) -->
  <div class="relative rounded-2xl border shadow-sm transition-all backdrop-blur-md overflow-hidden ring-2"
       [ngClass]="isDarkMode()
       ? 'bg-[#1e1e2f]/90 border-indigo-500/10 ring-blue-500/30'
       : 'bg-gray-50/90 border-gray-200 ring-blue-500/20'">
    <!-- 🔵 Sticky summary header (bridge) -->
    <div class="sticky top-0 z-10">
      <div class="rounded-t-2xl bg-gradient-to-r from-sky-600 via-blue-600 to-indigo-600 text-white">
        <div class="flex items-center justify-between px-3 py-2 gap-2">
          <div class="min-w-0 font-semibold text-xs sm:text-sm whitespace-pre-line [font-variant-numeric:tabular-nums]">
            {{ getBridgeSummaryLine() || '—' }}
          </div>
          <button type="button"
                  class="shrink-0 p-1.5 rounded-full hover:bg-white/10 active:scale-[0.98] transition"
                  (click)="onClose()"
                  [attr.aria-label]="'COMMON.CLOSE' | translate">
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                 stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      </div>
      <!-- Body wrapper (FIXE) — DANS le sticky -->
      <div class="px-4 py-4 md:px-5 md:py-5 pb-0 md:pb-0">
        <!-- ==== Header (provider + buy amount) ==== -->
        <div class="grid items-start gap-3"
             style="grid-template-columns:minmax(0,1fr) max-content;">
          <!-- Provider bloc -->
          <div class="flex items-center gap-2 min-w-0">
            <img *ngIf="getProviderLogo(quote)"
                 [src]="getProviderLogo(quote)"
                 class="w-7 h-7 rounded-full shadow-sm"
                 [alt]="'ALT.PROVIDER_LOGO' | translate" />
            <div class="flex flex-col min-w-0">
              <div class="font-semibold truncate"
                   [attr.title]="quote?.bridgeName || quote?.BridgeName || ('LABEL.BRIDGE' | translate)">
                {{ quote?.bridgeName || quote?.BridgeName || ('LABEL.BRIDGE' | translate) }}
              </div>
              <div class="mt-1.5 text-xs opacity-70">
                {{ getRateText(quote) }}
              </div>
            </div>
          </div>

          <!-- Amount received -->
          <div class="text-right leading-tight">
            <div class="text-lg md:text-2xl font-bold tracking-tight [font-variant-numeric:tabular-nums]">
              {{ getBuyAmountText(quote) }}
            </div>
            <div class="text-[11px] opacity-70">
              {{ getBuyFiatText(quote) }}
            </div>
          </div>
        </div>

        <!-- ==== Toolbar (Share / Details / Validate) ==== -->
        <div class="mt-3 flex items-center gap-1.5 flex-nowrap">
          <button type="button"
                  (click)="onShareClick()"
                  class="px-2.5 py-1 rounded-lg border text-[11px] sm:text-sm
               whitespace-nowrap shrink-0 shadow-sm transition
               hover:ring-2 hover:ring-indigo-500/30
               inline-flex items-center gap-1.5">
            <span>{{ 'BUTTON.SHARE' | translate }}</span>
            <!-- Icône "share" (arrow-up-tray, hérite de la couleur du texte) -->
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                 aria-hidden="true" focusable="false">
              <path d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5" />
              <path d="M7.5 7.5 12 3m0 0 4.5 4.5M12 3v12" />
            </svg>
          </button>


          <button type="button"
                  (click)="toggleMainDetails()"
                  class="px-2.5 py-1 rounded-lg border text-[11px] sm:text-sm
                 inline-flex items-center gap-1 whitespace-nowrap shrink-0 shadow-sm transition
                 hover:ring-2 hover:ring-indigo-500/30"
                  [attr.aria-label]="'ARIA.TOGGLE_DETAILS' | translate"
                  [attr.aria-expanded]="showMainDetails">
            <span>{{ showMainDetails ? ('BUTTON.HIDE' | translate) : ('BUTTON.DETAILS' | translate) }}</span>
            <svg class="w-3 h-3 sm:w-3.5 sm:h-3.5 transition-transform"
                 [ngClass]="showMainDetails ? 'rotate-180' : ''"
                 viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd"
                    d="M10 12a1 1 0 0 1-.7-.29l-4-4a1 1 0 1 1 1.4-1.42L10 9.59l3.3-3.3a1 1 0 1 1 1.4 1.42l-4 4A1 1 0 0 1 10 12z"
                    clip-rule="evenodd" />
            </svg>
          </button>

          <ng-container *ngIf="getMainCtaState() as cta">
            <!-- conteneur relatif pour positionner le popover au-dessus du bouton -->
            <div class="relative ml-auto z-[3000]">
              <button #mainCtaBtn type="button"
                      [disabled]="cta.disabled"
                      (click)="!cta?.disabled && onMainCtaClick()"
                      class="ml-auto px-3 py-1.5 rounded-xl border font-semibold text-[11px] sm:text-sm
                   whitespace-nowrap shrink-0 shadow-sm transition
                   enabled:hover:shadow enabled:hover:ring-2 enabled:hover:ring-blue-500/30
                   disabled:opacity-40 disabled:cursor-not-allowed"
                      [ngClass]="isDarkMode()
              ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white border-white/10'
              : 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white border-indigo-500/20'"
                      [attr.aria-label]="'ARIA.VALIDATE_ROUTE' | translate">
                {{ cta.label }}
              </button>
              <!-- Overlay cliquable au-dessus du bouton quand il est désactivé -->
              <div *ngIf="cta?.disabled"
                   class="absolute inset-0 z-[2600] cursor-not-allowed"
                   (click)="revealMainWhy()"
                   aria-hidden="true"></div>
              <!-- Popover “Why disabled” (MAIN) : affiché uniquement sur clic d’un bouton disabled -->
            </div>
          </ng-container>

        </div>

        <!-- ===== MAIN status (shown just under the action buttons) ===== -->
        <ng-container *ngIf="expandedAltIndex === null && lastAltStatusIndex == null && (statusNorm === 'approving'
                   || statusNorm === 'pending'
                   || statusNorm === 'success'
                   || statusNorm === 'cancelled'
                   || statusNorm === 'error')">
          <div class="mt-1.5 text-center text-[11px] sm:text-xs">
            <ng-container [ngSwitch]="statusNorm">
              <!-- Approve / Pending -->
              <div *ngSwitchCase="'approving'" class="text-blue-600 dark:text-blue-300">
                {{ 'STATUS.APPROVING' | translate : {} : 'Approving…' }}
              </div>
              <div *ngSwitchCase="'pending'" class="text-blue-600 dark:text-blue-300">
                {{ 'STATUS.PENDING' | translate : {} : 'Transaction in progress…' }}
              </div>
              <!-- Success -->
              <div *ngSwitchCase="'success'" class="text-green-600 dark:text-green-400">
                {{ 'STATUS.SUCCESS' | translate : {} : 'Transaction confirmed' }}
                <a *ngIf="bridgeHash"
                   class="underline ml-1"
                   target="_blank" rel="noopener"
                   [href]="getExplorerTxUrl(pickChainIdForTx(quote), bridgeHash)">
                  #{{ bridgeHash | slice:0:6 }}…{{ bridgeHash | slice:-4 }}
                </a>
              </div>
              <!-- Cancelled -->
              <div *ngSwitchCase="'cancelled'" class="text-gray-600 dark:text-gray-400">
                {{ 'STATUS.CANCELLED_BY_USER' | translate : {} : 'Transaction cancelled by user' }}
              </div>
              <!-- Error (always formatted, never raw) -->
              <div *ngSwitchCase="'error'" class="text-rose-600 dark:text-rose-400">
                {{ getFormattedBridgeError(bridgeError) || ('STATUS.ERROR' | translate : {} : 'Erreur durant le swap.') }}
              </div>
            </ng-container>
          </div>
        </ng-container>

        <!-- ==== Why disabled (main) — single line ==== -->
        <div *ngIf="showWhyMain && isWalletConnected() && bridgeDisabled && bridgeReasons?.length"
             class="mt-2 text-xs text-amber-700 dark:text-amber-400"
             aria-live="polite">
          {{ getMainFirstReasonLabel() }}
        </div>


        <!-- ==== Main details (BRIDGE) — card-separated, hidden when collapsed ==== -->
        <ng-container *ngIf="showMainDetails">
          <div class="mt-2">
            <div class="rounded-2xl px-3 py-2 md:py-3 border shadow-sm backdrop-blur-md"
                 [ngClass]="isDarkMode()
           ? 'bg-[#0b1020]/70 border-white/10'
           : 'bg-gray-50/90 border-gray-200'">

              <div class="grid gap-1 md:gap-2 md:grid-cols-2 text-[11px] sm:text-xs [font-variant-numeric:tabular-nums]">

                <!-- Min. garanti -->
                <div class="flex items-start justify-between leading-snug md:col-span-2">
                  <!-- conteneur relatif pour positionner le panneau -->
                  <span class="relative inline-flex items-center gap-1">
                    <span class="opacity-70">{{ 'MIN_GUARANTEED' | translate }}</span>
                    <!-- bouton “i” cercle -->
                    <button type="button"
                            (click)="toggleTooltip('slippage','main',$event)"
                            class="inline-flex items-center justify-center rounded-full cursor-pointer
                          h-4 w-4 p-0 leading-none appearance-none select-none ring-1 transition
                           focus:outline-none focus-visible:ring-0 active:ring-0
                           pointer-events-auto [-webkit-tap-highlight-color:transparent]"
                            [ngClass]="isDarkMode()
                      ? 'text-white/90 ring-white/30 hover:bg-white/10'
                      : 'text-gray-700 ring-black/10 hover:bg-black/5'">
                      <span class="text-[10px] font-semibold -mt-px">i</span>
                    </button>
                    <!-- tooltip -->
                    <div *ngIf="openedTooltip==='slippage:main'"
                         class="absolute z-50 left-0 -top-2 translate-y-[-100%] max-w-[260px]
                        rounded-xl border shadow-lg p-2 text-[11px] sm:text-xs leading-snug backdrop-blur-md"
                         [ngClass]="isDarkMode() ? 'bg-[#0b1020]/90 border-white/10' : 'bg-white/95 border-gray-200'"
                         (click)="$event.stopPropagation()">
                      <div class="opacity-80">{{ 'TOOLTIP.MIN_GUARANTEED' | translate }}</div>
                      <a class="mt-1 inline-block font-medium underline" target="_blank" rel="noopener"
                         [href]="getHelpUrl('slippage')">
                        {{ 'TOOLTIP.LEARN_MORE' | translate : {} : 'En savoir plus' }}
                      </a>
                    </div>
                  </span>
                  <span class="text-right leading-tight">
                    <span class="font-medium text-[11px] sm:text-sm">{{ getMainMinGuaranteed().amount }}</span>
                    <div class="opacity-70 text-[10px] sm:text-xs">(≈ {{ getMainMinGuaranteed().fiat }})</div>
                  </span>
                </div>

                <!-- Frais réseau -->
                <div class="flex items-start justify-between leading-snug md:col-span-2">
                  <span class="relative inline-flex items-center gap-1">
                    <span class="opacity-70">{{ 'NETWORK_FEE' | translate }}</span>
                    <!-- bouton “i” cercle -->
                    <button type="button"
                            (click)="toggleTooltip('network_fees','main',$event)"
                            class="inline-flex items-center justify-center rounded-full cursor-pointer
                  h-4 w-4 p-0 leading-none appearance-none select-none ring-1 transition
                  focus:outline-none focus-visible:ring-0 active:ring-0
                  pointer-events-auto [-webkit-tap-highlight-color:transparent]"
                            [ngClass]="isDarkMode()
             ? 'text-white/90 ring-white/30 hover:bg-white/10'
             : 'text-gray-700 ring-black/10 hover:bg-black/5'">
                      <span class="text-[10px] font-semibold -mt-px">i</span>
                    </button>
                    <!-- tooltip -->
                    <div *ngIf="openedTooltip==='network_fees:main'"
                         class="absolute z-50 left-0 -top-2 translate-y-[-100%] max-w-[260px]
               rounded-xl border shadow-lg p-2 text-[11px] sm:text-xs leading-snug backdrop-blur-md"
                         [ngClass]="isDarkMode() ? 'bg-[#0b1020]/90 border-white/10' : 'bg-white/95 border-gray-200'"
                         (click)="$event.stopPropagation()">
                      <div class="opacity-80">{{ 'TOOLTIP.NETWORK_FEE' | translate }}</div>
                      <a class="mt-1 inline-block font-medium underline" target="_blank" rel="noopener"
                         [href]="getHelpUrl('network_fees')">
                        {{ 'TOOLTIP.LEARN_MORE' | translate : {} : 'En savoir plus' }}
                      </a>
                    </div>
                  </span>
                  <span class="text-right leading-tight">
                    <span class="font-medium text-[11px] sm:text-sm">{{ getMainNetworkFeeText().native }}</span>
                    <div class="opacity-70 text-[10px] sm:text-xs">{{ getMainNetworkFeeText().fiat }}</div>
                  </span>
                </div>

                <!-- Frais bridge -->
                <div class="flex items-start justify-between leading-snug">
                  <span class="relative inline-flex items-center gap-1">
                    <span class="opacity-70">{{ 'BRIDGE_FEE' | translate }}</span>
                    <!-- bouton “i” cercle -->
                    <button type="button"
                            (click)="toggleTooltip('bridge_fees','main',$event)"
                            class="inline-flex items-center justify-center rounded-full cursor-pointer
                  h-4 w-4 p-0 leading-none appearance-none select-none ring-1 transition
                  focus:outline-none focus-visible:ring-0 active:ring-0
                  pointer-events-auto [-webkit-tap-highlight-color:transparent]"
                            [ngClass]="isDarkMode()
             ? 'text-white/90 ring-white/30 hover:bg-white/10'
             : 'text-gray-700 ring-black/10 hover:bg-black/5'">
                      <span class="text-[10px] font-semibold -mt-px">i</span>
                    </button>
                    <!-- tooltip -->
                    <div *ngIf="openedTooltip==='bridge_fees:main'"
                         class="absolute z-50 left-0 -top-2 translate-y-[-100%] max-w-[260px]
               rounded-xl border shadow-lg p-2 text-[11px] sm:text-xs leading-snug backdrop-blur-md"
                         [ngClass]="isDarkMode() ? 'bg-[#0b1020]/90 border-white/10' : 'bg-white/95 border-gray-200'"
                         (click)="$event.stopPropagation()">
                      <div class="opacity-80">{{ 'TOOLTIP.BRIDGE_FEE' | translate }}</div>
                      <a class="mt-1 inline-block font-medium underline" target="_blank" rel="noopener"
                         [href]="getHelpUrl('bridge_fees')">
                        {{ 'TOOLTIP.LEARN_MORE' | translate : {} : 'En savoir plus' }}
                      </a>
                    </div>
                  </span>
                  <span class="font-medium text-right text-[11px] sm:text-sm">{{ getMainBridgeFeeText() }}</span>
                </div>

                <!-- Impact prix -->
                <div class="flex items-start justify-between leading-snug">
                  <span class="relative inline-flex items-center gap-1">
                    <span class="opacity-70">{{ 'PRICE_IMPACT' | translate }}</span>
                    <!-- bouton “i” cercle -->
                    <button type="button"
                            (click)="toggleTooltip('price_impact','main',$event)"
                            class="inline-flex items-center justify-center rounded-full cursor-pointer
                  h-4 w-4 p-0 leading-none appearance-none select-none ring-1 transition
                  focus:outline-none focus-visible:ring-0 active:ring-0
                  pointer-events-auto [-webkit-tap-highlight-color:transparent]"
                            [ngClass]="isDarkMode()
             ? 'text-white/90 ring-white/30 hover:bg-white/10'
             : 'text-gray-700 ring-black/10 hover:bg-black/5'">
                      <span class="text-[10px] font-semibold -mt-px">i</span>
                    </button>
                    <!-- tooltip -->
                    <div *ngIf="openedTooltip==='price_impact:main'"
                         class="absolute z-50 left-0 -top-2 translate-y-[-100%] max-w-[260px]
               rounded-xl border shadow-lg p-2 text-[11px] sm:text-xs leading-snug backdrop-blur-md"
                         [ngClass]="isDarkMode() ? 'bg-[#0b1020]/90 border-white/10' : 'bg-white/95 border-gray-200'"
                         (click)="$event.stopPropagation()">
                      <div class="opacity-80">{{ 'TOOLTIP.PRICE_IMPACT' | translate }}</div>
                      <a class="mt-1 inline-block font-medium underline" target="_blank" rel="noopener"
                         [href]="getHelpUrl('price_impact')">
                        {{ 'TOOLTIP.LEARN_MORE' | translate : {} : 'En savoir plus' }}
                      </a>
                    </div>
                  </span>
                  <span class="font-medium text-[11px] sm:text-sm">{{ getPriceImpactPct(quote) }}</span>
                </div>

                <!-- Temps estimé -->
                <div class="flex items-start justify-between leading-snug md:col-span-2">
                  <span class="relative inline-flex items-center gap-1">
                    <span class="opacity-70">{{ 'ESTIMATED_TIME' | translate }}</span>
                    <button type="button"
                            (click)="toggleTooltip('estimated_time','main',$event)"
                            class="inline-flex items-center justify-center rounded-full cursor-pointer
                   h-4 w-4 p-0 leading-none appearance-none select-none ring-1 transition
                   focus:outline-none focus-visible:ring-0 active:ring-0
                   pointer-events-auto [-webkit-tap-highlight-color:transparent]"
                            [ngClass]="isDarkMode()
              ? 'text-white/90 ring-white/30 hover:bg-white/10'
              : 'text-gray-700 ring-black/10 hover:bg-black/5'">
                      <span class="text-[10px] font-semibold -mt-px">i</span>
                    </button>
                    <div *ngIf="openedTooltip==='estimated_time:main'"
                         class="absolute z-50 left-0 -top-2 translate-y-[-100%] max-w-[260px]
                rounded-xl border shadow-lg p-2 text-[11px] sm:text-xs leading-snug backdrop-blur-md"
                         [ngClass]="isDarkMode() ? 'bg-[#0b1020]/90 border-white/10' : 'bg-white/95 border-gray-200'"
                         (click)="$event.stopPropagation()">
                      <div class="opacity-80">{{ 'TOOLTIP.ESTIMATED_TIME' | translate }}</div>
                      <a class="mt-1 inline-block font-medium underline" target="_blank" rel="noopener"
                         [href]="getHelpUrl('estimated_time')">
                        {{ 'TOOLTIP.LEARN_MORE' | translate : {} : 'En savoir plus' }}
                      </a>
                    </div>
                  </span>
                  <span class="font-medium text-[11px] sm:text-sm">{{ secondsToText(getEstimatedTimeSec(quote)) }}</span>
                </div>

              </div>

            </div>
          </div>
        </ng-container>




        <!-- ==== Alternatives header ==== -->
        <div *ngIf="computedOtherRoutes?.length" class="mt-1">
          <button type="button"
                  (click)="toggleAlternatives()"
                  class="px-3 py-1.5 rounded-lg border text-[11px] sm:text-sm shadow-sm inline-flex items-center gap-2 transition
                     hover:ring-2 hover:ring-indigo-500/30"
                  [ngClass]="isDarkMode()
                ? 'border-indigo-500/10'
                : 'border-indigo-500/20'"
                  [attr.aria-label]="'ARIA.TOGGLE_ALTERNATIVES' | translate"
                  [attr.aria-expanded]="showAlternatives">
            <span>
              {{ showAlternatives ? ('ALTERNATIVES.HIDE' | translate) : ('ALTERNATIVES.COUNT' | translate:{ count: computedOtherRoutes.length }) }}
            </span>
            <svg class="w-3.5 h-3.5 transition-transform"
                 [ngClass]="showAlternatives ? 'rotate-180' : ''"
                 viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd"
                    d="M10 12a1 1 0 0 1-.7-.29l-4-4a1 1 0 1 1 1.4-1.42L10 9.59l3.3-3.3a1 1 0 1 1 1.4 1.42l-4 4A1 1 0 0 1 10 12z"
                    clip-rule="evenodd" />
            </svg>
          </button>
        </div> <!-- fin du body wrapper FIXE -->
      </div> <!-- fin du sticky étendu -->
      <!-- ==== Alternatives list (SCROLLABLE SEULEMENT ICI) ==== -->
      <div *ngIf="computedOtherRoutes?.length && showAlternatives"
           #altScrollArea
           class="relative z-[30]  px-4 md:px-5 mt-2
                overflow-y-auto
                max-h-[calc(100svh-270px)] md:max-h-[calc(100svh-290px)]">
        <div class="mt-1.5 space-y-1.5">
          <div *ngFor="let r of computedOtherRoutes; let i = index">
            <ng-container *ngIf="expandedAltIndex === null || expandedAltIndex === i">
              <div class="relative z-[70] rounded-xl border p-3 shadow-sm"
                   [ngClass]="isDarkMode()
                   ? 'bg-[#1e1e2f]/70 border-indigo-500/10'
                   : 'bg-white/70 border-indigo-500/10'"
                   data-alt-card>

                <!-- Provider (ALTERNATIVE) -->
                <div class="grid items-center gap-2" style="grid-template-columns:minmax(0,1fr) max-content;">
                  <div class="flex items-center gap-1.5 min-w-0">
                    <img *ngIf="getProviderLogo(r)" [src]="getProviderLogo(r)"
                         class="w-4 h-4 rounded-full shadow-sm" [alt]="'ALT.PROVIDER_LOGO' | translate" />
                    <div class="truncate font-medium text-[11px] sm:text-[12px] md:text-sm"
                         [attr.title]="r?.bridgeName || r?.BridgeName || getProviderName(r)">
                      {{ r?.bridgeName || r?.BridgeName || getProviderName(r) }}
                    </div>

                    <!-- Gas gauge (même icône que Swap) -->
                    <span class="ml-1 inline-flex items-center gap-1 rounded-full px-1 py-0.5 ring-1"
                          [ngClass]="{
            'bg-green-500/15 ring-green-400/20' : !isAltValidateDisabled(r),
            'bg-amber-500/15 ring-amber-400/20' :  isAltValidateDisabled(r)
          }"
                          [attr.title]="!isAltValidateDisabled(r) ? ('TOOLTIP.GAS_OK'|translate)
                                                 : ('TOOLTIP.GAS_MED'|translate)"
                          [attr.aria-label]="!isAltValidateDisabled(r) ? ('TOOLTIP.GAS_OK'|translate)
                                                      : ('TOOLTIP.GAS_MED'|translate)">
                      <svg viewBox="0 0 24 24" class="h-3.5 w-3.5">
                        <!-- base demi-cercle -->
                        <path d="M3 13a9 9 0 0 1 18 0" fill="none" stroke="currentColor" stroke-width="2" opacity="0.35" />
                        <!-- aiguille + moyeu -->
                        <g [ngClass]="{
              'text-green-500' : !isAltValidateDisabled(r),
              'text-amber-500' :  isAltValidateDisabled(r)
            }">
                          <path d="M12 12 L18 12"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                class="transform origin-center"
                                [ngClass]="{
                  'rotate-[-45deg]' : !isAltValidateDisabled(r),
                  'rotate-0'        :  isAltValidateDisabled(r)
                }" />
                          <circle cx="12" cy="12" r="1" fill="currentColor"></circle>
                        </g>
                      </svg>
                      <!-- libellé (affiché dès md) -->
                      <span class="hidden md:inline text-[10px] font-medium"
                            [ngClass]="{
              'text-green-700 dark:text-green-300' : !isAltValidateDisabled(r),
              'text-amber-700 dark:text-amber-300' :  isAltValidateDisabled(r)
            }">
                        {{ !isAltValidateDisabled(r) ? ('BADGE.GAS_OK'|translate) : ('BADGE.GAS_MED'|translate) }}
                      </span>
                    </span>
                  </div>

                  <div class="text-right leading-tight">
                    <div class="text-sm md:text-base font-semibold [font-variant-numeric:tabular-nums]">
                      {{ getBuyAmountText(r) }}
                    </div>
                    <div class="text-[10px] opacity-70">
                      {{ getBuyFiatText(r) }}
                    </div>
                  </div>
                </div>


                <!-- Subline -->
                <div class="mt-0.5 flex items-center gap-1.5 text-[11px] md:text-xs opacity-70"
                     [ngClass]="{ 'hidden md:flex': expandedAltIndex === i }">
                  <div class="flex-1 truncate">{{ getRateText(r) }}</div>
                  <!-- Bouton Détails : capsule premium -->
                  <!-- Bouton Détails – compact mobile, normal dès md (thème bleu / bridge) -->
                  <button type="button"
                          (click)="toggleAlt(i)"
                          [attr.aria-label]="'ARIA.TOGGLE_ALT_DETAILS' | translate"
                          [attr.aria-expanded]="(expandedAltIndex === i) ? 'true' : 'false'"
                          class="group inline-flex items-center rounded-full p-[1px] shadow-sm transition active:scale-[0.99]
               bg-gradient-to-r from-sky-500 to-blue-600 whitespace-nowrap w-auto shrink-0
               md:inline-flex"
                          [ngClass]="{ 'hidden': expandedAltIndex === i }">

                    <span class="inline-flex items-center gap-1 rounded-full
               px-2 py-1 min-h-[28px] text-[11px] font-semibold
               ring-1 ring-white/10 group-hover:ring-white/20 text-white
               md:gap-1.5 md:px-3.5 md:py-2 md:min-h-[36px] md:text-[13px]">
                      <span>
                        {{ (expandedAltIndex === i) ? ('BUTTON.CLOSE' | translate) : ('BUTTON.DETAILS' | translate) }}
                      </span>

                      <span class="inline-flex h-4 w-4 items-center justify-center rounded-full
                 bg-white/15 ring-1 ring-white/15 transition
                 group-hover:bg-white/20
                 md:h-5 md:w-5">
                        <svg viewBox="0 0 24 24" fill="none"
                             class="h-3 w-3 md:h-3.5 md:w-3.5 transition-transform duration-200"
                             [ngClass]="(expandedAltIndex === i) ? 'rotate-180' : 'rotate-0'"
                             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M6 9l6 6 6-6" />
                        </svg>
                      </span>
                    </span>
                  </button>




                </div>

                <!-- Alt details (BRIDGE) — card-separated, hidden when collapsed -->
                <ng-container *ngIf="expandedAltIndex === i">
                  <div class="mt-1">
                    <div class="rounded-2xl px-3 py-2 md:py-3 border shadow-sm backdrop-blur-md"
                         [ngClass]="isDarkMode()
           ? 'bg-[#0b1020]/70 border-white/10'
           : 'bg-gray-50/90 border-gray-200'">

                      <div class="grid gap-1 md:gap-2 md:grid-cols-2 text-[11px] sm:text-xs [font-variant-numeric:tabular-nums]">

                        <!-- Frais réseau -->
                        <div class="flex items-start justify-between leading-snug md:col-span-2">
                          <span class="relative inline-flex items-center gap-1">
                            <span class="opacity-70">{{ 'NETWORK_FEE' | translate }}</span>
                            <!-- bouton “i” cercle -->
                            <button type="button"
                                    (click)="toggleTooltip('network_fees','alt-'+i,$event)"
                                    class="inline-flex items-center justify-center rounded-full cursor-pointer
                     h-4 w-4 p-0 leading-none appearance-none select-none ring-1 transition
                     focus:outline-none focus-visible:ring-0 active:ring-0
                     pointer-events-auto [-webkit-tap-highlight-color:transparent]"
                                    [ngClass]="isDarkMode()
                ? 'text-white/90 ring-white/30 hover:bg-white/10'
                : 'text-gray-700 ring-black/10 hover:bg-black/5'">
                              <span class="text-[10px] font-semibold -mt-px">i</span>
                            </button>
                            <!-- tooltip -->
                            <div *ngIf="openedTooltip===('network_fees:alt-'+i)"
                                 class="absolute left-0 top-full mt-2 z-[2600] max-w-[260px]
                  rounded-xl border shadow-lg p-2 text-[11px] sm:text-xs leading-snug backdrop-blur-md"
                                 [ngClass]="isDarkMode() ? 'bg-[#0b1020]/90 border-white/10' : 'bg-white/95 border-gray-200'"
                                 (click)="$event.stopPropagation()">
                              <div class="opacity-80">{{ 'TOOLTIP.NETWORK_FEE' | translate }}</div>
                              <a class="mt-1 inline-block font-medium underline" target="_blank" rel="noopener"
                                 [href]="getHelpUrl('network_fees')">
                                {{ 'TOOLTIP.LEARN_MORE' | translate : {} : 'En savoir plus' }}
                              </a>
                            </div>
                          </span>
                          <span class="text-right leading-tight">
                            <span class="font-medium text-[11px] sm:text-sm">{{ getAltNetworkFeeText(r).native }}</span>
                            <div class="opacity-70 text-[10px] sm:text-xs">{{ getAltNetworkFeeText(r).fiat }}</div>
                          </span>
                        </div>

                        <!-- Frais bridge -->
                        <div class="flex items-start justify-between leading-snug">
                          <span class="relative inline-flex items-center gap-1">
                            <span class="opacity-70">{{ 'BRIDGE_FEE' | translate }}</span>
                            <button type="button"
                                    (click)="toggleTooltip('bridge_fees','alt-'+i,$event)"
                                    class="inline-flex items-center justify-center rounded-full cursor-pointer
                  h-4 w-4 p-0 leading-none select-none ring-1 transition
                  focus:outline-none focus-visible:ring-0 active:ring-0
                  pointer-events-auto [-webkit-tap-highlight-color:transparent]"
                                    [ngClass]="isDarkMode()
             ? 'text-white/90 ring-white/30 hover:bg-white/10'
             : 'text-gray-700 ring-black/10 hover:bg-black/5'">
                              <span class="text-[10px] font-semibold -mt-px">i</span>
                            </button>
                            <!-- tooltip: sous le label (évite le recouvrement du header sticky) -->
                            <div *ngIf="openedTooltip===('bridge_fees:alt-'+i)"
                                 class="absolute left-0 top-full mt-2 z-[2600] max-w-[260px]
               rounded-xl border shadow-lg p-2 text-[11px] sm:text-xs leading-snug backdrop-blur-md"
                                 [ngClass]="isDarkMode() ? 'bg-[#0b1020]/90 border-white/10' : 'bg-white/95 border-gray-200'"
                                 (click)="$event.stopPropagation()">
                              <div class="opacity-80">{{ 'TOOLTIP.BRIDGE_FEE' | translate }}</div>
                              <a class="mt-1 inline-block font-medium underline" target="_blank" rel="noopener"
                                 [href]="getHelpUrl('bridge_fees')">
                                {{ 'TOOLTIP.LEARN_MORE' | translate : {} : 'En savoir plus' }}
                              </a>
                            </div>
                          </span>
                          <span class="font-medium text-right text-[11px] sm:text-sm">{{ getAltBridgeFeeText(r) }}</span>
                        </div>

                        <!-- Impact prix -->
                        <div class="flex items-start justify-between leading-snug">
                          <span class="relative inline-flex items-center gap-1">
                            <span class="opacity-70">{{ 'PRICE_IMPACT' | translate }}</span>
                            <!-- bouton “i” cercle (scopé alt-i) -->
                            <button type="button"
                                    (click)="toggleTooltip('price_impact','alt-'+i,$event)"
                                    class="inline-flex items-center justify-center rounded-full cursor-pointer
                   h-4 w-4 p-0 leading-none select-none ring-1 transition
                   focus:outline-none focus-visible:ring-0 active:ring-0
                   pointer-events-auto [-webkit-tap-highlight-color:transparent]"
                                    [ngClass]="isDarkMode()
              ? 'text-white/90 ring-white/30 hover:bg-white/10'
              : 'text-gray-700 ring-black/10 hover:bg-black/5'">
                              <span class="text-[10px] font-semibold -mt-px">i</span>
                            </button>
                            <!-- tooltip sous le label (évite le header sticky) -->
                            <div *ngIf="openedTooltip===('price_impact:alt-'+i)"
                                 class="absolute left-0 top-full mt-2 z-[2600] max-w-[260px]
                rounded-xl border shadow-lg p-2 text-[11px] sm:text-xs leading-snug backdrop-blur-md"
                                 [ngClass]="isDarkMode() ? 'bg-[#0b1020]/90 border-white/10' : 'bg-white/95 border-gray-200'"
                                 (click)="$event.stopPropagation()">
                              <div class="opacity-80">{{ 'TOOLTIP.PRICE_IMPACT' | translate }}</div>
                              <a class="mt-1 inline-block font-medium underline" target="_blank" rel="noopener"
                                 [href]="getHelpUrl('price_impact')">
                                {{ 'TOOLTIP.LEARN_MORE' | translate : {} : 'En savoir plus' }}
                              </a>
                            </div>
                          </span>
                          <span class="font-medium text-[11px] sm:text-sm">{{ getRoutePriceImpact(r) }}</span>
                        </div>

                        <!-- Temps estimé -->
                        <div class="flex items-start justify-between leading-snug">
                          <span class="relative inline-flex items-center gap-1 min-w-0">
                            <span class="opacity-70">{{ 'ESTIMATED_TIME' | translate }}</span>
                            <!-- bouton “i” cercle (scope alt-i) -->
                            <button type="button"
                                    (click)="toggleTooltip('estimated_time','alt-'+i,$event)"
                                    class="inline-flex items-center justify-center rounded-full cursor-pointer
                   h-4 w-4 p-0 leading-none select-none ring-1 transition
                   focus:outline-none focus-visible:ring-0 active:ring-0
                   pointer-events-auto [-webkit-tap-highlight-color:transparent]"
                                    [ngClass]="isDarkMode()
              ? 'text-white/90 ring-white/30 hover:bg-white/10'
              : 'text-gray-700 ring-black/10 hover:bg-black/5'">
                              <span class="text-[10px] font-semibold -mt-px">i</span>
                            </button>
                            <!-- tooltip sous le label (évite le header sticky) -->
                            <div *ngIf="openedTooltip===('estimated_time:alt-'+i)"
                                 class="absolute left-0 top-full mt-2 z-[2600] max-w-[260px]
                rounded-xl border shadow-lg p-2 text-[11px] sm:text-xs leading-snug backdrop-blur-md"
                                 [ngClass]="isDarkMode() ? 'bg-[#0b1020]/90 border-white/10' : 'bg-white/95 border-gray-200'"
                                 (click)="$event.stopPropagation()">
                              <div class="opacity-80">{{ 'TOOLTIP.ESTIMATED_TIME' | translate }}</div>
                              <a class="mt-1 inline-block font-medium underline" target="_blank" rel="noopener"
                                 [href]="getHelpUrl('estimated_time')">
                                {{ 'TOOLTIP.LEARN_MORE' | translate : {} : 'En savoir plus' }}
                              </a>
                            </div>
                          </span>
                          <span class="font-medium text-[11px] sm:text-sm shrink-0">
                            {{ secondsToText(getEstimatedTimeSec(r)) }}
                          </span>
                        </div>
                        <!-- Min. garanti -->
                        <div class="flex items-start justify-between leading-snug md:col-span-2">
                          <span class="relative inline-flex items-center gap-1">
                            <span class="opacity-70">{{ 'MIN_GUARANTEED' | translate }}</span>
                            <!-- bouton “i” cercle (scope alt-i) -->
                            <button type="button"
                                    (click)="toggleTooltip('slippage','alt-'+i,$event)"
                                    class="inline-flex items-center justify-center rounded-full cursor-pointer
                  h-4 w-4 p-0 leading-none select-none ring-1 transition
                  focus:outline-none focus-visible:ring-0 active:ring-0
                   pointer-events-auto [-webkit-tap-highlight-color:transparent]"
                                    [ngClass]="isDarkMode()
              ? 'text-white/90 ring-white/30 hover:bg-white/10'
              : 'text-gray-700 ring-black/10 hover:bg-black/5'">
                              <span class="text-[10px] font-semibold -mt-px">i</span>
                            </button>
                            <!-- tooltip sous le label (évite le header sticky) -->
                            <div *ngIf="openedTooltip===('slippage:alt-'+i)"
                                 class="absolute left-0 top-full mt-2 z-[2600] max-w-[260px]
                rounded-xl border shadow-lg p-2 text-[11px] sm:text-xs leading-snug backdrop-blur-md"
                                 [ngClass]="isDarkMode() ? 'bg-[#0b1020]/90 border-white/10' : 'bg-white/95 border-gray-200'"
                                 (click)="$event.stopPropagation()">
                              <div class="opacity-80">{{ 'TOOLTIP.MIN_GUARANTEED' | translate }}</div>
                              <a class="mt-1 inline-block font-medium underline" target="_blank" rel="noopener"
                                 [href]="getHelpUrl('slippage')">
                                {{ 'TOOLTIP.LEARN_MORE' | translate : {} : 'En savoir plus' }}
                              </a>
                            </div>
                          </span>
                          <span class="text-right leading-tight">
                            <span class="font-medium text-[12px] sm:text-sm">{{ getAltMinGuaranteed(r).amount }}</span>
                            <div class="opacity-70 text-[10px] sm:text-xs">(≈ {{ getAltMinGuaranteed(r).fiat }})</div>
                          </span>
                        </div>

                        <!-- Bloc statut (au-dessus des CTA) — affiché seulement pour CETTE alternative -->
                        <ng-container *ngIf="getAltStatusFor(i) !== 'idle'">
                          <div class="md:col-span-2 mt-1.5 mb-1 text-center text-[11px] sm:text-xs">
                            <ng-container [ngSwitch]="getAltStatusFor(i)">
                              <div *ngSwitchCase="'approving'" class="text-blue-600 dark:text-blue-300">
                                {{ 'STATUS.APPROVING' | translate : {} : 'Approving…' }}
                              </div>
                              <div *ngSwitchCase="'pending'" class="text-blue-600 dark:text-blue-300">
                                {{ 'STATUS.PENDING' | translate : {} : 'Transaction in progress…' }}
                              </div>
                              <div *ngSwitchCase="'success'" class="text-green-600 dark:text-green-400">
                                {{ 'STATUS.SUCCESS' | translate : {} : 'Transaction confirmed' }}
                                <a *ngIf="bridgeHash"
                                   class="underline ml-1" target="_blank" rel="noopener"
                                   [href]="getExplorerTxUrl(pickChainIdForTx(r), bridgeHash)">
                                  #{{ bridgeHash | slice:0:6 }}…{{ bridgeHash | slice:-4 }}
                                </a>
                              </div>
                              <div *ngSwitchCase="'cancelled'" class="text-gray-600 dark:text-gray-400">
                                {{ 'STATUS.CANCELLED_BY_USER' | translate : {} : 'Transaction cancelled by user' }}
                              </div>
                              <div *ngSwitchCase="'error'" class="text-rose-600 dark:text-rose-400">
                                {{ getFormattedBridgeError(bridgeError) || ('STATUS.ERROR' | translate : {} : 'Erreur durant le swap.') }}
                              </div>
                            </ng-container>
                          </div>
                        </ng-container>
                        <!-- Why disabled (ALT i) — single line -->
                        <div *ngIf="showWhyAlt[i] && (getAltCtaState(r)?.disabled) && (getAltReasons(r)?.length)"
                             class="mt-1 text-[11px] sm:text-xs"
                             [ngClass]="isDarkMode() ? 'text-amber-300' : 'text-amber-700'"
                             aria-live="polite">
                          {{ getAltFirstReasonLabel(r) }}
                        </div>

                        <!-- CTA -->
                        <div class="flex items-center justify-end md:col-span-2">
                          <ng-container *ngIf="getAltCtaState(r) as a">
                            <div class="flex gap-2 items-center">
                              <!-- Bouton Fermer (mobile quand carte ouverte) -->
                              <button *ngIf="expandedAltIndex === i"
                                      (click)="toggleAlt(i)"
                                      type="button"
                                      class="px-3 py-1.5 rounded-xl border font-semibold text-xs sm:text-sm shadow-sm transition
                     enabled:hover:shadow enabled:hover:ring-2 enabled:hover:ring-blue-500/30
                     disabled:opacity-40 disabled:cursor-not-allowed"
                                      [ngClass]="isDarkMode()
                ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white border-white/10'
                : 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white border-indigo-500/20'">
                                {{ 'COMMON.CLOSE' | translate }}
                              </button>

                              <!-- Bouton Valider + overlay disabled (scopé au bouton uniquement) -->
                              <div class="relative">
                                <button #altBtn type="button"
                                        [disabled]="a.disabled"
                                        (click)="!a?.disabled && onAltCtaClick(r)"
                                        class="px-3 py-1.5 rounded-xl border font-semibold text-xs sm:text-sm shadow-sm transition
                       enabled:hover:shadow enabled:hover:ring-2 enabled:hover:ring-blue-500/30
                       disabled:opacity-40 disabled:cursor-not-allowed"
                                        [ngClass]="isDarkMode()
                  ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white border-white/10'
                  : 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white border-indigo-500/20'">
                                  {{ a.label }}
                                </button>

                                <!-- Overlay au-dessus du bouton Valider uniquement -->
                                <div *ngIf="a.disabled"
                                     class="absolute inset-0 z-[2600] cursor-not-allowed"
                                     (click)="revealAltWhy(i)"
                                     aria-hidden="true"></div>
                              </div>
                            </div>
                          </ng-container>
                        </div>




                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </div>
        <!-- ==== Footer sticky (déplié + dépasse écran) ==== -->
        <div *ngIf="showStickyFooter"
             class="sticky bottom-0  px-4 md:px-5 pt-3 pb-4 z-[120]
            relative overflow-hidden"
             [ngClass]="isDarkMode() ? 'bg-[#0b1020]/70' : 'bg-gray-50/90'"
             style="bottom: max(env(safe-area-inset-bottom), 0px);
            padding-bottom: max(env(safe-area-inset-bottom), 1rem)">
          <!-- couche base OPAQUE (masque) : empêche de voir les cartes en dessous -->
          <div class="absolute inset-0 "
               [ngClass]="isDarkMode() ? 'bg-[#1e1e2f]' : 'bg-white'"></div>

          <!-- (optionnel) petit glow pour homogénéiser la lumière bleue -->
          <div class="absolute inset-0 pointer-events-none
              bg-gradient-to-r from-indigo-600/10 to-blue-600/10"></div>

          <!-- contenu au-dessus -->
          <div class="relative">
            <button type="button" (click)="onClose()" class="w-full inline-flex items-center justify-center rounded-2xl px-4 py-2.5
                                            text-sm font-semibold text-white shadow-sm transition active:scale-[0.99]
                                            focus:outline-none focus:ring-2 focus:ring-sky-400/40
                                            bg-gradient-to-r from-sky-600 via-blue-600 to-indigo-600
                                            hover:from-sky-500 hover:via-blue-500 hover:to-indigo-500
                                            border border-white/10 drop-shadow-[0_6px_20px_rgba(59,130,246,0.25)]">
              {{ 'COMMON.CLOSE' | translate }}
            </button>
          </div>
        </div>



      </div>


      <!-- ==== Footer statique (seulement quand plié) ==== -->
      <div *ngIf="!showStickyFooter" class="mt-4 px-4 pb-4 md:px-5 md:pb-5">
        <button type="button" (click)="onClose()" class="w-full inline-flex items-center justify-center rounded-2xl px-4 py-2.5
                                               text-sm font-semibold text-white shadow-sm transition active:scale-[0.99]
                                               focus:outline-none focus:ring-2 focus:ring-sky-400/40
                                               bg-gradient-to-r from-sky-600 via-blue-600 to-indigo-600
                                               hover:from-sky-500 hover:via-blue-500 hover:to-indigo-500
                                               border border-white/10 drop-shadow-[0_6px_20px_rgba(59,130,246,0.25)]">
          {{ 'COMMON.CLOSE' | translate }}
        </button>
      </div>

      <!-- ← fermeture du panneau principal (garde-la ici) -->




</div>
</div>
</div>
